import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";

const Layout = ({ children }) => {
  const [userData, setUserData] = useState(localStorage.getItem("userData"));
  const navigate = useNavigate();

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (!userData) navigate("/");
    setUserData(userData);
  }, []);

  return (
    <div className="flex min-h-screen overflow-x-hidden">
      <Sidebar />
      <div className="flex-1 md:ml-[255px] ml-12 transition-all duration-300">
        <Navbar userData={userData} setuserData={setUserData} />
        <div className="  bg-gray-100 min-h-screen">
          {children ? children : <Outlet />}
        </div>
      </div>
    </div>
  );
};

export default Layout;